import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';
import type { GameBlocksRaw, GameBlocks, GameItems, Filters, Game } from '@/types';
import createQueryString from '@/utils/queryString';
import { appendItems } from '@/utils/appendItems';
import { getAuthHeaders } from '@/utils/getHeaders';
import { usePlayer } from '@/composables/usePlayer';
import { useLocalization } from '@/composables/useLocalization';
import { gameBlocksAdapter } from '@/adapters/adapters';
export const useGameBlocksStore = defineStore('gameBlocks', () => {
    const { isPlayer } = usePlayer();
    const { defaultLanguageCode } = useLocalization();
    const gameBlocks = ref<GameBlocks[]>([]);
    const gamesByBlock = ref<Record<string, GameItems>>({});
    function toToggleBlockLoading(id: number | undefined) {
        if (!id) return;
        gameBlocks.value.forEach((item) => {
            if (item.id === id) {
                item.loading = !item.loading;
            }
        });
    }
    function toSetIsBlockHaveGames(id: number | undefined) {
        if (!id) return;
        gameBlocks.value.forEach((item) => {
            if (item.id === id) {
                item.isHaveGames = true;
            }
        });
    }
    function toUpdateGameBlockFavoriteStatus(game: Game, action: 'add' | 'delete'): void {
        const isFavourite = action === 'add';

        // Update games in all blocks
        Object.keys(gamesByBlock.value).forEach((blockName) => {
            gamesByBlock.value[blockName].items = gamesByBlock.value[blockName].items.map((item) => (item.id === game.id ? { ...item, is_favourite: isFavourite } : item));
        });
    }
    const awaitGetGameBlocks = async () => {
        try {
            const response = await axios.get<GameBlocksRaw[]>(`/main-api/games/blocks?language_code=${defaultLanguageCode.value}`);
            if (response.status === 200) {
                const rd = gameBlocksAdapter(response.data);
                gameBlocks.value = rd;
            }
        } catch (error) {
            console.error(error);
        }
    };
    const awaitGetGamesByBlock = async (filters: Filters, id?: number) => {
        const gameBlockName = filters.block_string_id as string;
        const queryString = createQueryString(filters);
        if (id) {
            toToggleBlockLoading(id);
        }
        const headers = isPlayer.value ? getAuthHeaders() : {};
        const endpoint = `/main-api/games${isPlayer.value ? '/my' : ''}/filter${queryString}`;
        await axios
            .get<GameItems>(endpoint, headers)
            .then((response) => {
                if (response?.status === 200) {
                    const gamesData = response.data;
                    if (gameBlockName !== undefined) {
                        if (filters.page >= 2) {
                            appendItems(gamesByBlock, gamesData, gameBlockName);
                        } else if (filters.page === 1) {
                            gamesByBlock.value[gameBlockName] = gamesData;
                        }
                    } else {
                        console.warn('cant find block_string_id');
                    }
                    if (id) {
                        toSetIsBlockHaveGames(id);
                    }
                }
            })
            .catch((error) => {
                throw error;
            });
        if (id) {
            toToggleBlockLoading(id);
        }
    };
    return { toUpdateGameBlockFavoriteStatus, gameBlocks, awaitGetGameBlocks, awaitGetGamesByBlock, gamesByBlock };
});
